
import Layout from "../components/Layout";
import { RescateClientes } from "../components/rescateClientes";

const RescatesClientes = () => {
	return (
		<>      
		<Layout/>
		<RescateClientes/>
		</>
	);
}

export default RescatesClientes; 